var l_test_var = 0;